<template>
    <div ref="chart" class="c-chart"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    components: {},
    props: {
        option: {
            // echart 配置项
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {
        initChart() {
            let option = this.option;
            if (!this.$echartInstance) {
                // 如果echart实例没有创建则创建echart
                let chartDom = this.$refs.chart;
                const myChart = echarts.init(chartDom);
                this.$echartInstance = myChart;
            }

            this.$echartInstance.setOption(option);
        },
    },
    created() {},
    mounted() {
        this.initChart();
    },
    watch: {
        option: {
            handler() {
                this.initChart();
            },

            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.c-chart {
    height: 100%;
    width: 100%;
}
</style>
